
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ServicesSection from './components/ServicesSection';
import ExpertiseSection from './components/ExpertiseSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import ContactFormSection from './components/ContactFormSection';
import StatsSection from './components/StatsSection';
import ProjectsSection from './components/ProjectsSection';

const CoatingInspectionPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Coating Inspection Services - HP Inc Consulting Services | Industrial Coating Quality Control"
        description="Professional coating inspection services for industrial and marine applications. Expert coating inspectors providing quality control, surface preparation assessment, and coating performance evaluation."
        keywords="coating inspection, industrial coating inspection, marine coating inspection, coating quality control, surface preparation inspection, coating performance evaluation, NACE inspector, SSPC inspector, coating failure analysis"
        canonical="https://hpincconsultant.com/coating-inspection"
        ogTitle="Coating Inspection Services - Professional Quality Control"
        ogDescription="Expert coating inspection and quality control services for industrial and marine coating applications."
        ogUrl="https://hpincconsultant.com/coating-inspection"
      />
      <Header />
      <main>
        <HeroSection />
        <IntroSection />
        <ServicesSection />
        <ExpertiseSection />
        <StatsSection />
        <WhyChooseUsSection />
        <ProjectsSection />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
};

export default CoatingInspectionPage;
